import React, {useRef, useEffect, useState, useMemo} from 'react';
import dayjs from 'dayjs';
import {isEqual} from 'lodash';

import Grid from '@mui/material/Grid';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';

import {DEFAULT_CITY} from 'ultra/const/general';
import {getClientCity} from 'ultra/configs/general';
import {getClientCityTimezone} from 'ultra/configs/general';
import {getFormatedDate, timestampToDate, isTimestamp} from 'ultra/helpers/date'

import {ukLocale} from '../../../Helpers/locale';
import {useConfigStore} from '../../../Stores/config';
import {useFormStore} from '../../../Stores/form';

import './index.scss'

export default function DateField(props) {
    const {content, disabled, field, isEditMode, onChange, onBlur} = props

    const {formVisibleErrors} = useFormStore()
    const showErrorText = formVisibleErrors[field.id]

    const [placeholder] = useState((field?.placeholder ? field?.placeholder : '') + (field?.required ? ' *' : ''))

    const {configs} = useConfigStore()

    const [timeZone, setTimeZone] = useState()
    useEffect(() => {
        const city = content._city || getClientCity(window) || DEFAULT_CITY;
        setTimeZone(getClientCityTimezone(configs, city));
    }, [configs])

    const [isDisabled, setIsDisabled] = useState(disabled || field?.options?.disabled || (isEditMode && field.notEditable))
    useEffect(() => {setIsDisabled(disabled || field?.options?.disabled || (isEditMode && field.notEditable)) }, [disabled])

    const [value, setValue] = useState(null)

    const componentRef = useRef(null);

    const valueRef = useRef(null);
    const setValueRef = data => {
        valueRef.current = data;
    };

    const [ignoreControlCheck, setIgnoreControlCheck] = useState(false);

    const className = useMemo(() => {
        let result = "DateField";
        result += isDisabled ? ' disabled' : ''
        result += (!ignoreControlCheck && showErrorText) ? ' error' : ''
        return result;
    }, [isDisabled, showErrorText, ignoreControlCheck])

    const hasInteractionRef = useRef(null);
    const setHasInteraction = data => {
        hasInteractionRef.current = data;
    };

    const handleClickOutside = (e) => {
        const clickOutside = componentRef.current && !componentRef.current.contains(e.target);

        if (!hasInteractionRef.current) {
            if (!clickOutside) setHasInteraction(true);
        }
        else if (clickOutside) {
            setIgnoreControlCheck(false);
            onBlur({target: {value: valueRef.current}});
        }
        else {
            setIgnoreControlCheck(true);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
          document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        let newValue
        if (content[field.id]) {
            if (isTimestamp(content[field.id])) {
                newValue = dayjs(timestampToDate(content[field.id]))
            } else {
                newValue = dayjs(content[field.id], 'DD.MM.YYYY')
            }
        }
        else {
            newValue = null
        }

        setValueRef(newValue);

        // if (!isEqual(value, newValue))
            setValue(newValue);
    }, [content[field.id]])

    const onDateChange = (e) => {
        onChange({target: { value: getFormatedDate(e, timeZone) }})
    }

    return (<Grid className={className} key={field.id} item xs={12}>
        <div ref={componentRef} className="DateFieldWrap" style={{display: "inline-block"}}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="uk" localeText={ukLocale}>
                <DesktopDatePicker
                    closeOnSelect
                    label={placeholder}
                    disabled={isDisabled}
                    value={value}
                    onChange={onDateChange}
                    timezone={timeZone}
                />
            </LocalizationProvider>
            {!ignoreControlCheck && showErrorText && <div className='fieldError'>
                {showErrorText}
            </div>}
        </div>
    </Grid>)
}
